<template>
  <OtherTours
    v-if="links.length"
    title="Туры по дням"
    :links="links"
  />
</template>

<script lang="ts" setup>
  import { onMounted, ref } from 'vue';

  import { getLinksList, type Links, type GetLinksListData } from '@/shared/api/experience';
  import { useCategoryStore } from '@/shared/store';
  import OtherTours from '@/shared/ui/OtherTours/index.vue';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';

  const categoryStore = useCategoryStore();
  const links = ref<Links | never[]>([]);

  const fetchData = async () => {
    if (!categoryStore.filters[EExperienceFilterType.SEO_DEFAULT]?.city) {
      return;
    }

    const params: GetLinksListData = {
      url: '/api/seo/v2/category/cities-tours-days-by-city/{cityId}/',
      path: { cityId: categoryStore.filters[EExperienceFilterType.SEO_DEFAULT].city },
      query: {
        except_hours: categoryStore.filters[EExperienceFilterType.SEO_DEFAULT]?.startDuration
          ? Number(categoryStore.filters[EExperienceFilterType.SEO_DEFAULT].startDuration)
          : undefined,
      },
    };

    const { data } = await getLinksList(params);

    if (!data) {
      return;
    }

    links.value = data as Links;
  };

  onMounted(() => {
    fetchData();
  });
</script>
